<template>
	<div>
		<form>
			<div class="form-group row">
				<label for="" class="col-sm-2 col-form-label col-form-label-sm" style="float: left" >*Designativo:</label>
				<div class="col-sm-5">
					<input type="text"
							class="form-control form-control-sm"
							@input="form.icao = $event.target.value.toUpperCase()"
							v-model="form.icao">
				</div>
			</div>

			<div class="form-group row">
				<label for="" class="col-sm-2 col-form-label col-form-label-sm" style="float: left" >*IATA:</label>
				<div class="col-sm-5">
					<input type="text"
							class="form-control form-control-sm"
							@input="form.iata = $event.target.value.toUpperCase()"
							v-model="form.iata">
				</div>
			</div>

			<div class="form-group row">
				<label for="" class="col-sm-2 col-form-label col-form-label-sm">*Aeroporto:</label>
				<div class="col-md-10">
					<input type="text"
							class="form-control form-control-sm"
							@input="form.nome = $event.target.value.toUpperCase()"
							v-model="form.nome">
				</div>
			</div>
			<div class="form-group row">
				<label class="col-sm-2 col-form-label col-form-label-sm">*Cidade:</label>
				<div class="col-md-10">
					<input type="text"
							class="form-control form-control-sm"
							@input="form.cidade = $event.target.value.toUpperCase()"
							v-model="form.cidade">
				</div>
			</div>
			<div class="form-group row">
				<label for="" class="col-sm-2 col-form-label col-form-label-sm">*País:</label>
				<div class="col-md-10">
					<input type="text"
							class="form-control form-control-sm"
							@input="form.pais = $event.target.value.toUpperCase()"
							v-model="form.pais">
				</div>
			</div>
			<div class="form-group row">
				<label for="" class="col-sm-2 col-form-label col-form-label-sm">Latitude:</label>
				<div class="col-md-5">
					<input type="text"
						   class="form-control form-control-sm"
						   @input="form.latitude = $event.target.value.toUpperCase()"
						   v-model="form.latitude">
				</div>
			</div>
			<div class="form-group row">
				<label for="" class="col-sm-2 col-form-label col-form-label-sm">Longitude:</label>
				<div class="col-md-5">
					<input type="text"
						   class="form-control form-control-sm"
						   @input="form.longitude = $event.target.value.toUpperCase()"
						   v-model="form.longitude">
				</div>
			</div>
			<div class="form-group row">
				<label for="" class="col-sm-2 col-form-label col-form-label-sm">Altitude:</label>
				<div class="col-md-4">
					<input type="number" class="form-control form-control-sm" v-model="form.altitude">
				</div>
			</div>

			<hr />

			<div class="row">
				<div class="col-sm-12 text-right">
					<small class="float-left text-info">
						<fa-icon icon="info-circle" transform="left-3" />Campos com * são obrigatórios.
					</small>
					<button @click.prevent="salva()" class="btn btn-success btn-sm" :disabled="desabilitar">
						<fa-icon icon="check" transform="left-3" /> SALVAR
					</button>
				</div>
			</div>
		</form>
	</div>
</template>
<script>
import axios from '../../../routers/axios'

export default {

	data(){
		return {
			form: {
				id: 0,
				nome: '',
				icao: '',
				iata: '',
				cidade: '',
				pais: '',
				latitude: '',
				longitude: '',
				altitude: 0
			},

		}
	},

	computed: {

		desabilitar(){
			if(this.form.icao != '' && this.form.nome != '' && this.form.cidade != '' && this.form.pais != ''){
				return false
			}else{
				return true
			}
		}
	},

	methods: {

		editar(item){
			this.form = item
		},

		salva(){

            var data = {
				id: this.form.id,
				nome: this.form.nome,
				cidade: this.form.cidade,
				pais: this.form.pais,
				icao: this.form.icao,
				iata: this.form.iata,
				latitude: this.form.latitude,
				longitude: this.form.longitude,
				altitude: this.form.altitude
            }


			this.$notify.loadIn('Salvando')

			if(this.form.id != 0){

				axios.put(this._getUrl('api/Local/' + data.id), data).then(response => {

					this.$notify.show('success', 'Editado com sucesso.')
					this.$emit('atualizar', response.data)
				})
			}else{

				axios.post(this._getUrl('api/Local'), data).then(response => {

					this.$notify.show('success', 'Cadastrado com sucesso.')
					this.$emit('atualizar', response.data)
					this.form.id = response.data.id
				})
			}
        }

	}
}
</script>



// WEBPACK FOOTER //
// src/views/followair/local/cadastro.vue